/* jshint strict: true */
/* jshint esversion: 11 */

import rawCss from './x-close.pcss';

const modalTemplate = document.createElement('template');
modalTemplate.innerHTML = `
		<style>${rawCss}</style>
    <button class="x-close" tabindex="0" aria-label="Click to close dialog"></button>`;

export class XClose extends HTMLElement {
	static componentName = 'x-close';
	static EVENT_NAME = 'x-close-was-clicked';

	constructor() {
		super();
		const shadow = this.attachShadow({ mode: 'open' });
		shadow.appendChild(modalTemplate.content.cloneNode(true));
	}

	connectedCallback() {
		let theme;

		let lightTheme = this.getAttribute('light');
		let darkTheme = this.getAttribute('dark');

		if (lightTheme) {
			theme = 'light';
		} else if (darkTheme) {
			theme = 'dark';
		} else {
			theme = 'dark';
		}

		this.shadowRoot.querySelector('button').classList.add(`x-close--${theme}`);
		this.shadowRoot.querySelector('button').addEventListener('click', this.emit.bind(this, XClose.EVENT_NAME, {}));
	}

	disconnectedCallback() {
		this.shadowRoot.querySelector('button').removeEventListener('click', this.emit.bind(this, XClose.EVENT_NAME, {}));
	}

	emit(eventName: string, data: any = {}) {
		const eventToDispatch = new CustomEvent(eventName, {
			detail: data,
			bubbles: true,
			composed: true
		});
		this.dispatchEvent(eventToDispatch);
	}
}
